import {
  StyledInput,
  Container,
  Icon,
} from './styles';

const Input = ({
  error,
  inputRef,
  ...props
}) => (
  <Container>
    <Icon className={props.value ? 'icon-heart-filled' : 'icon-heart'} />
    <StyledInput
      readOnly={props.readOnly}
      onClick={props.readOnly ? undefined : () => props.onChange(!props.value)}
    >
      {props.value ? 'Remove from wishlist' : 'Add to wishlist'}
    </StyledInput>
    <input type="hidden" ref={inputRef} />
  </Container>
);

export default Input;
